module.exports = __webpack_public_path__ + "static/media/ic_search.23e68bf2.svg";